import { render } from "./TakingOrders.vue?vue&type=template&id=6799e762"
import script from "./TakingOrders.vue?vue&type=script&lang=js"
export * from "./TakingOrders.vue?vue&type=script&lang=js"

import "./TakingOrders.vue?vue&type=style&index=0&id=6799e762&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__